import React from "react";
import WarningIcon from "../Shared/icons/WarningIcon";
import "./MriChargesMismatchBanner.scss";

export const MRI_CHARGES_MISMATCH_BANNER_TEXT =
  "Charges do not match MRI. Lease edits, add-ons and resident changes are locked until MRI and LD agree.";

const MriChargesMismatchBanner: React.FC = () => (
  <div className="mri-charges-mismatch-banner" role="alert">
    <WarningIcon className="mismatch-icon" />
    <strong>{MRI_CHARGES_MISMATCH_BANNER_TEXT}</strong>
  </div>
);

export default MriChargesMismatchBanner;
